import * as React from "react"

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    //width={1.63}
    //height={96.309}
    viewBox="0 0 100 100"
    {...props}
  >
    <path
      d="m342.772 426-.072 96.309v-1.35"
      style={{
        fill: "none",
        fillOpacity: 1,
        fillRule: "evenodd",
        stroke: "#4ec3e0",
        strokeWidth: 1.55811,
        strokeDasharray: "none",
        strokeOpacity: 1,
      }}
      transform="translate(-341.921 -426)"
    />
  </svg>
)

export default SvgComponent
